import React from 'react';
import { InfoTableRows } from './infoTable';
import { getUnitProperty } from '../../schemas/unitSchema';

export const UnitInfoTable = ({
  selectedUnitItem,
  menderStatus
}) => {
  const menderStatusLabel = menderStatus
    ? menderStatus.charAt(0).toUpperCase() + menderStatus.slice(1)
    : '-';

  const menderStatusColor = menderStatus === 'connected'
    ? '#28a745'
    : menderStatus === 'disconnected'
      ? '#dc3545'
      : undefined;

  return (
    <table className="table main-background table-responsive">
      <tbody>
        <InfoTableRows
          statusInfo={selectedUnitItem}
          data={[
            { label: 'Organization', key: 'organization' },
            { label: 'Center', key: 'center' },
            { label: 'Unit', key: 'unit' },
            { label: 'Sensor Serial', key: 'kpod_id' },
            { label: 'Display Serial', key: 'display_id' }
          ]}
        />
        <tr className="text-start">
          <td><strong className="text-muted">Description</strong></td>
          <td className="text-end text-muted" style={{ wordBreak: "break-word" }}>
            {getUnitProperty(selectedUnitItem, 'description', 'No description')}
          </td>
        </tr>
        <tr className="text-start">
          <td><strong className="text-muted">Mender Status</strong></td>
          <td
            className={menderStatusColor ? 'text-end' : 'text-end text-muted'}
            style={menderStatusColor ? { color: menderStatusColor } : undefined}
          >
            {menderStatusLabel}
          </td>
        </tr>
      </tbody>
    </table>
  );
};